import Channels from "./Channels";
import Currencies from "./Currencies";
import styles from "./filters-dropdowns.module.scss";

const FiltersDropdowns = () => {

  return (
    <div className={styles["filters-dropdowns-wrapper"]}>
      <Channels />
      <Currencies />
    </div>
  )
}

export default FiltersDropdowns;